import { useState, useEffect } from "react";
import { createPortal } from 'react-dom';
import eventBus from 'Util/eventBus';
import './outline.css';

const GuideOutline = () => {
  const [guide, setGuide] = useState("");

  useEffect(() => {
    const handleGuideEvent = (val) => {
      setGuide(val);
    };
    eventBus.on('guideOutlineEvent', handleGuideEvent);

    return () => {
      eventBus.off('guideOutlineEvent', handleGuideEvent);
    };
  }, []);

function renderingContent() {
    if (guide === 'per') {
      return (
        <div className="content">
          <div className="upper">PER (Price Earnings Ratio, 주가수익비율)</div>
          <div className="text">
            <strong>PER: 주가 / 주당순이익(EPS)</strong>
            <br /><br />
            기업이 벌어들이는 이익에 비해 주가가 어떻게 평가받고 있는지를 나타내는 지표입니다.
            <br /><br />
            기업의 수익이 일정하다고 가정할 때, 투자 원금을 회수하는 데 걸리는 기간을 의미합니다. 일반적으로 낮을수록 저평가된 것으로 간주합니다.
          </div>
        </div>
      );
    } else if (guide === 'pbr') {
      return (
        <div className="content">
          <div className="upper">PBR (Price to Book Ratio, 주가순자산비율)</div>
          <div className="text">
            <strong>PBR: 주가 / 주당순자산(BPS)</strong>
            <br /><br />
            주가와 기업의 재무 상태(순자산)를 비교하는 지표입니다.
            <br /><br />
            기업을 청산했을 때 주주가 받을 수 있는 가치를 나타냅니다. <strong>1보다 낮으면 시가총액이 장부가치보다 낮다는 의미로, 자산 가치 대비 저평가</strong>된 상태로 판단합니다.
          </div>
        </div>
      );
    } else if (guide === 'psr') {
      return (
        <div className="content">
          <div className="upper">PSR (Price Sales Ratio, 주가매출비율)</div>
          <div className="text">
            <strong>PSR: 주가 / 주당매출액(SPS)</strong>
            <br /><br />
            주가를 1주당 매출액으로 나눈 값으로, 현재 주가가 매출액의 몇 배인지 나타냅니다.
            <br /><br />
            이익이 발생하지 않는 성장 초기 단계의 기업을 평가할 때 주로 활용하며, <strong>수치가 낮을수록 성장성 대비 주가가 저평가</strong>된 것으로 봅니다.
          </div>
        </div>
      );
    } else if (guide === 'roe') {
      return (
        <div className="content">
          <div className="upper">ROE (Return On Equity, 자기자본이익률)</div>
          <div className="text">
            <strong>ROE: (당기순이익 / 자기자본) X 100</strong>
            <br /><br />
            투입한 자기자본을 활용해 한 해 동안 얼마만큼의 이익을 냈는지 보여주는 수익성 지표입니다.
            <br /><br />
            <strong>수치가 높을수록 자본을 효율적으로 운용</strong>하고 있음을 의미하며, 최소한 시중 금리나 자본 조달 비용보다 높은 수준을 유지하는 것이 바람직합니다.
          </div>
        </div>
      );
    } else if (guide === 'der') {
      return (
        <div className="content">
          <div className="upper">순부채비율</div>
          <div className="text">
            <strong>순부채비율: (총차입금 - 현금성자산) / 자기자본 X 100</strong>
            <br /><br />
            실질적인 부채 부담을 측정하는 지표로, 기업이 보유한 현금으로 빚을 얼마나 갚을 수 있는지 나타냅니다.
            <br /><br />
            <strong>마이너스(-) 비율은 보유한 현금이 빌린 돈보다 많다는 의미</strong>이며, 이는 매우 우수한 재무 안정성을 갖추고 있음을 시사합니다.
          </div>
        </div>
      );
    } else if (guide === 'div') {
      return (
        <div className="content">
          <div className="upper">배당수익률</div>
          <div className="text">
            <strong>배당수익률: (주당배당금 / 주가) X 100</strong>
            <br /><br />
            현재 주가로 주식을 매수했을 때 기대할 수 있는 배당금의 비율입니다.
            <br /><br />
            <strong>배당수익률이 높을수록</strong> 주가 하락 시 방어 역할을 하는 안전판이 되며, 기업의 이익 창출 능력이 안정적이고 주주 환원 의지가 강하다는 것을 의미합니다.
          </div>
        </div>
      );
    }
    return null;
  }

  // create a portal container so popup is rendered at document.body level
  const [portalEl, setPortalEl] = useState(null);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const el = document.createElement('div');
    document.body.appendChild(el);
    setPortalEl(el);
    return () => {
      try { document.body.removeChild(el); } catch (e) {}
    };
  }, []);

  const popupMarkup = (
    <div className={(guide && guide !== "") ? "stock_popup is-active" : "stock_popup"}>
      <div className="popup" style={guide ? { maxHeight: 'calc(100vh - 16px)', margin: '8px', maxWidth: '92%' } : {}}>
        <button
          className="popup-close"
          onClick={(e) => {
            e.preventDefault();
            setGuide("");
          }}
          aria-label="닫기"
        >
          ×
        </button>
        {renderingContent()}
        <div className="button">
          <button
            className="close"
            onClick={(e) => {
              e.preventDefault();
              setGuide("");
            }}
          >확인</button>
        </div>
      </div>
      <div className="dimmed"></div>
    </div>
  );

  if (!portalEl) return null;
  return guide ? createPortal(popupMarkup, portalEl) : null;
};

export default GuideOutline;
